import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { CollapseSideNavigationComponent } from './collapse-side-navigation/collapse-side-navigation.component';
import { CustomDatePickerComponent } from './custom-date-picker/custom-date-picker.component';
import { CustomInputTextComponent } from './custom-input-text/custom-input-text.component';
import { CustomAutoCompleteComponent } from './custom-auto-complete/custom-auto-complete.component';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { LoadingComponent } from './loading/loading.component';
import { DialogMessageComponent } from './dialog-message/dialog-message.component';
import { DxcModule } from '../dxc.module';
import { CustomTextareaComponent } from './custom-textarea/custom-textarea.component';
import { RouterModule } from '@angular/router';
import { ExternalModule } from '../external.module';
import { MobileSidenavComponent } from './mobile-sidenav/mobile-sidenav.component';
import { CustomAccordionComponent } from './custom-accordion/custom-accordion.component';
import { MobileHeaderComponent } from './mobile-header/mobile-header.component';
import { CustomerSurveyRatingComponent } from './customer-survey-rating/customer-survey-rating.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';

import { CustomButtonComponent } from './custom-button/custom-button.component';
import { ProposalDetailsComponent } from './components/proposal-details/proposal-details.component';
import { PdfViewComponent } from './components/pdf-view/pdf-view.component';
import { CustomAlertComponent } from './custom-alert/custom-alert.component';
import { HelpPopupComponent } from './components/help-popup/help-popup.component';
import { CustomToggleGroupComponent } from './custom-toggle-group/custom-toggle-group.component';
import { CustomFileInputComponent } from './custom-file-input/custom-file-input.component';
import { DialogShareEmailComponent } from './components/dialog-share-email/dialog-share-email.component';
import { CommonDialogShowDetailsComponent } from './common-dialog-show-details/common-dialog-show-details.component';
import { BmiAndQuestionaireComponent } from '../partial/process-claims/claim-review/details/bmi-and-questionaire/bmi-and-questionaire.component';
import { ViewBeneficiaryComponent } from '../partial/process-claims/claim-review/details/view-beneficiary/view-beneficiary.component';
import { RequirementsComponent } from '../partial/process-claims/claim-review/details/requirements/requirements.component';
import { UnderwritingCommentsComponent } from '../partial/process-claims/claim-review/details/underwriting-comments/underwriting-comments.component';
import { LoadingInformationComponent } from '../partial/process-claims/claim-review/details/loading-information/loading-information.component';
import { PolicyInquiryComponent } from '../partial/process-claims/claim-review/details/policy-inquiry/policy-inquiry.component';
import { DirectivesModule } from './directives/directives.module';
import { ProcessClaimNotesComponent } from './process-claim-notes/process-claim-notes.component';
import { InvestigationSubtaskNotesComponent } from './investigation-subtask-notes/investigation-subtask-notes.component';
import { BeneficiaryRequirementNotesComponent } from './beneficiary-requirement-notes/beneficiary-requirement-notes.component';
import { RequirementsBankDetailsComponent } from './requirements-bank-details/requirements-bank-details.component';
import { FactsDialogComponent } from './facts-dialog/facts-dialog.component';
import { ActivitiesOfDailyLivingComponent } from './activities-of-daily-living/activities-of-daily-living.component';
import { HospitalizationDetailsComponent } from './hospitalization-details/hospitalization-details.component';
import { PhysicianInformationComponent } from './physician-information/physician-information.component';
import { PreviousIllnessInfoComponent } from './previous-illness-info/previous-illness-info.component';
import { NatureAndExtentOfInjuriesComponent } from './nature-and-extent-of-injuries/nature-and-extent-of-injuries.component';
import { EyeWitnessComponent } from './eye-witness/eye-witness.component';
import { PoliceStationInfoComponent } from './police-station-info/police-station-info.component';
import { DocumentRequirementNotesComponent } from './document-requirement-notes/document-requirement-notes.component';
import { OtherInsuranceClaimDetailsComponent } from './components/other-insurance-claim-details/other-insurance-claim-details.component';
import { OccupationDetailsComponent } from './occupation-details/occupation-details.component';
import { SelfEmployeeDetailsComponent } from './self-employee-details/self-employee-details.component';
import { PositionMainDutiesComponent } from './position-main-duties/position-main-duties.component';
import { NotesComponent } from './components/notes/notes.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    CollapseSideNavigationComponent,
    CustomDatePickerComponent,
    CustomAccordionComponent,
    CustomInputTextComponent,
    CustomAutoCompleteComponent,
    CustomSelectComponent,
    CustomDropdownComponent,
    LoadingComponent,
    DialogMessageComponent,
    CustomTextareaComponent,
    MobileSidenavComponent,
    MobileHeaderComponent,
    CustomerSurveyRatingComponent,
    ConfirmationDialogComponent,

    CustomButtonComponent,
    ProposalDetailsComponent,
    PdfViewComponent,
    CustomAlertComponent,
    HelpPopupComponent,
    CustomToggleGroupComponent,
    CustomFileInputComponent,
    DialogShareEmailComponent,
    CommonDialogShowDetailsComponent,
    ViewBeneficiaryComponent,
    BmiAndQuestionaireComponent,
    RequirementsComponent,
    UnderwritingCommentsComponent,
    LoadingInformationComponent,
    PolicyInquiryComponent,
    ProcessClaimNotesComponent,
    InvestigationSubtaskNotesComponent,
    BeneficiaryRequirementNotesComponent,
    RequirementsBankDetailsComponent,
    FactsDialogComponent,
    ActivitiesOfDailyLivingComponent,
    HospitalizationDetailsComponent,
    PhysicianInformationComponent,
    PreviousIllnessInfoComponent,
    NatureAndExtentOfInjuriesComponent,
    EyeWitnessComponent,
    PoliceStationInfoComponent,
    DocumentRequirementNotesComponent,
    OtherInsuranceClaimDetailsComponent,
    OccupationDetailsComponent,
    SelfEmployeeDetailsComponent,
    PositionMainDutiesComponent,
    NotesComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    DxcModule,
    RouterModule,
    ExternalModule,
    MatDialogModule,
    DirectivesModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    TranslateModule,
    CollapseSideNavigationComponent,
    CustomAccordionComponent,
    CustomDatePickerComponent,
    CustomInputTextComponent,
    CustomAutoCompleteComponent,
    CustomSelectComponent,
    CustomDropdownComponent,
    LoadingComponent,
    DialogMessageComponent,
    CustomTextareaComponent,
    MobileSidenavComponent,
    MobileHeaderComponent,
    CustomerSurveyRatingComponent,
    ConfirmationDialogComponent,
    MatDialogModule,

    CustomButtonComponent,
    ProposalDetailsComponent,
    PdfViewComponent,
    CustomAlertComponent,
    HelpPopupComponent,
    CustomToggleGroupComponent,
    CustomFileInputComponent,
    CommonDialogShowDetailsComponent,
    DirectivesModule,
    ProcessClaimNotesComponent,
    InvestigationSubtaskNotesComponent,
    BeneficiaryRequirementNotesComponent,
    RequirementsBankDetailsComponent,
    FactsDialogComponent,
    ActivitiesOfDailyLivingComponent,
    HospitalizationDetailsComponent,
    PhysicianInformationComponent,
    PreviousIllnessInfoComponent,
    NatureAndExtentOfInjuriesComponent,
    EyeWitnessComponent,
    PoliceStationInfoComponent,
    OccupationDetailsComponent,
    SelfEmployeeDetailsComponent,
    PositionMainDutiesComponent,
    NotesComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
